export const isExistingUser = (identityIsValid: boolean, hasPreferredPaymentMethod: boolean, hasOrders: boolean): boolean =>
  identityIsValid && hasPreferredPaymentMethod && hasOrders
